import type { ThemeMode } from '@onyx/types'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAppStore = defineStore('app', () => {
  const theme = ref<ThemeMode>('system')
  const sidebarCollapsed = ref(false)
  const globalLoading = ref(false)

  function setTheme(mode: ThemeMode) {
    theme.value = mode
    localStorage.setItem('sales-theme', mode)
  }

  function toggleSidebar() {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }

  function init() {
    const saved = localStorage.getItem('sales-theme') as ThemeMode | null
    if (saved) theme.value = saved
  }

  return { theme, sidebarCollapsed, globalLoading, setTheme, toggleSidebar, init }
})
